__turbopack_context__.v({
  "body": "welcome-module__DfqkqW__body",
  "brand": "welcome-module__DfqkqW__brand",
  "brandCity": "welcome-module__DfqkqW__brandCity",
  "clay": "welcome-module__DfqkqW__clay",
  "count": "welcome-module__DfqkqW__count",
  "dot": "welcome-module__DfqkqW__dot",
  "dots": "welcome-module__DfqkqW__dots",
  "fall": "welcome-module__DfqkqW__fall",
  "fine": "welcome-module__DfqkqW__fine",
  "flourish": "welcome-module__DfqkqW__flourish",
  "foot": "welcome-module__DfqkqW__foot",
  "grain": "welcome-module__DfqkqW__grain",
  "ink": "welcome-module__DfqkqW__ink",
  "leaving": "welcome-module__DfqkqW__leaving",
  "mark": "welcome-module__DfqkqW__mark",
  "next": "welcome-module__DfqkqW__next",
  "paper": "welcome-module__DfqkqW__paper",
  "rise": "welcome-module__DfqkqW__rise",
  "sage": "welcome-module__DfqkqW__sage",
  "script": "welcome-module__DfqkqW__script",
  "skip": "welcome-module__DfqkqW__skip",
  "stage": "welcome-module__DfqkqW__stage",
  "title": "welcome-module__DfqkqW__title",
  "top": "welcome-module__DfqkqW__top",
  "welcome": "welcome-module__DfqkqW__welcome",
});
